module.exports = __webpack_public_path__ + "img/parpar_yes.4d0f66a8.png";